var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 8v1h1V8H6zm12 0h-1v1h1V8zM6.75 18a1 1 0 1 0 0-2v2zm10.5-2a1 1 0 1 0 0 2v-2zM13 14a1 1 0 1 0-2 0h2zm-1 9-.707.707a1 1 0 0 0 1.414 0L12 23zm3.707-2.293a1 1 0 0 0-1.414-1.414l1.414 1.414zm-6-1.414a1 1 0 0 0-1.414 1.414l1.414-1.414zM5.5 16A3.5 3.5 0 0 1 2 12.5H0A5.5 5.5 0 0 0 5.5 18v-2zM22 12.5a3.5 3.5 0 0 1-3.5 3.5v2a5.5 5.5 0 0 0 5.5-5.5h-2zM18.5 9a3.5 3.5 0 0 1 3.5 3.5h2A5.5 5.5 0 0 0 18.5 7v2zm-13-2A5.5 5.5 0 0 0 0 12.5h2A3.5 3.5 0 0 1 5.5 9V7zM12 2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7v2zm0-2a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5V0zM7 8V7H5v1h2zM5.5 9H6V7h-.5v2zM18 9h.5V7H18v2zm-1-2v1h2V7h-2zM6.75 16H5.5v2h1.25v-2zm11.75 0h-1.25v2h1.25v-2zM11 14v9h2v-9h-2zm1.707 9.707 3-3-1.414-1.414-3 3 1.414 1.414zm0-1.414-3-3-1.414 1.414 3 3 1.414-1.414z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.f5d5e175.svg";
export { ForwardRef as ReactComponent };